import { z } from 'zod';
import type { TipoFinais } from '../../../../../@types/IPA/PrecoPsicologico';
import { MIN_VALOR_ATE_POR_TIPO } from '../../constants';

const FINAIS_POR_TIPO: Record<number, RegExp> = {
  1: /^[0-9]$/,
  2: /^[0-9]{2}$/,
  3: /^[0-9],[0-9]{2}$/,
  4: /^[0-9]{2},[0-9]{2}$/,
  5: /^[0-9]{3},[0-9]{2}$/,
};

export const faixaDePrecoSchema = z
  .object({
    valorDe: z
      .number({ invalid_type_error: 'Informe um valor válido.' })
      .positive('Valor deve ser maior que zero.'),
    valorAte: z
      .number({ invalid_type_error: 'Informe um valor válido.' })
      .positive('Valor deve ser maior que zero.'),
    tipo: z.number().min(1).max(5),
    opcaoArredondamento: z.enum(['MAIS_PROXIMO', 'SEMPRE_PARA_CIMA', 'SEMPRE_PARA_BAIXO'], {
      required_error: 'Selecione uma opção de arredondamento.',
    }),
    finaisPermitidos: z.array(z.string()).min(1, 'Ao menos um final é obrigatório.'),
    usuarioId: z.string().min(1),
  })
  .refine(data => data.valorAte > data.valorDe, {
    message: 'Valor até deve ser maior que valor de.',
    path: ['valorAte'],
  })
  .refine(
    data => data.valorAte >= MIN_VALOR_ATE_POR_TIPO[data.tipo as TipoFinais],
    data => ({
      message: `Para ${data.tipo} dígito(s), o "Valor até" precisa ser no mínimo R$ ${MIN_VALOR_ATE_POR_TIPO[data.tipo as TipoFinais]}.`,
      path: ['tipo'],
    })
  )
  .refine(
    data => {
      const regex = FINAIS_POR_TIPO[data.tipo];
      return data.finaisPermitidos.every(f => regex?.test(f));
    },
    data => ({
      message: `Tipo ${data.tipo} aceita apenas finais no formato correto.`,
      path: ['finaisPermitidos'],
    })
  )
  .refine(
    data => {
      const naoVazios = data.finaisPermitidos.filter(Boolean);
      return new Set(naoVazios).size === naoVazios.length;
    },
    { message: 'Não é permitido adicionar finais repetidos.', path: ['finaisPermitidos'] }
  );

export type FaixaDePrecoFormData = z.infer<typeof faixaDePrecoSchema>;
